import styled, { css } from 'styled-components';
import { CancelIcon, CheckmarkIcon, colors, spacing } from '@chegg-ui/theme';
var grey700 = colors.grey700,
  cheggOrange = colors.cheggOrange;
export var StyledProductFeaturesList = styled.ul.withConfig({
  componentId: "sc-yp2q2c-0"
})(["list-style-type:none;text-align:left;"]);
export var StyledProductFeaturesListItem = styled.li.withConfig({
  componentId: "sc-yp2q2c-1"
})(["padding:", " 0;font-weight:500;padding-left:14px;", " display:flex;align-items:baseline;"], spacing.px4, function (_ref) {
  var isIncluded = _ref.isIncluded;
  return !isIncluded && "color: ".concat(grey700, ";");
});
var iconStyles = css(["position:relative;top:4px;margin-right:17px;"]);
export var StyledIncludedIcon = styled(CheckmarkIcon).withConfig({
  componentId: "sc-yp2q2c-2"
})(["", ";color:", ";"], iconStyles, cheggOrange);
export var StyledNotIncludedIcon = styled(CancelIcon).withConfig({
  componentId: "sc-yp2q2c-3"
})(["", ";color:", ";"], iconStyles, grey700);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductFeaturesList/styled.js
// module id = 1399
// module chunks = 11